import styled from '@emotion/styled';
import { Container, Navbar } from 'react-bootstrap';

import theme from 'styles/theme';

const shouldForwardProp = (prop: string) => !['openElement'].includes(prop);

type OpenElement = {
  openElement?: boolean;
};

export const IconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  & > div:last-child > div:first-child > div:first-child {
    border: 2px solid #fff;
    border-radius: 999px;
    overflow: hidden;
  }
`;

export const MobileGuideButton = styled.button`
  display: none;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 6px;
  background: ${theme.colors.mediumPurple};
  color: #fff;
  align-items: center;
  justify-content: center;
  outline: none;

  svg {
    font-size: 18px;
  }

  &:hover {
    background: #328cfd;
  }
`;

export const Divider = styled.div`
  width: 1px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.35);

  @media (max-width: 1100px) {
    display: none;
  }
`;

export const NavLogo = styled.div`
  padding: 0 55px;
  margin-top: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Logo = styled.img`
  width: 100%;
`;

export const MenuItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;
  margin-top: 25px;
`;

export const MenuItem = styled.div`
  height: 36px;
  margin-bottom: 12px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  &:hover {
    border-width: 0px;
    border-left-width: 3px;
    border-style: solid;
    border-color: ${theme.colors.green};
    font-family: 'Mangueira bold';
  }
  transition: 0.5s border-color;
`;

export const MenuItemLink = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const MenuItemText = styled.span`
  font-size: 15px;
  color: #fff;
  margin-left: 16px;
`;

export const SocialContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  flex-direction: row;
  padding-bottom: 30px;

  a + a {
    margin-left: 12px;
  }
`;

export const SocialIcon = styled.a`
  color: #fff;
  text-decoration: none !important;
  font-size: 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  &:hover {
    filter: brightness(0.7);
  }

  transition: 0.5s color;

  svg {
    width: 27px;
    height: 27px;
    flex-shrink: 0;
  }
`;

export const ContentMenuBurger = styled.div`
  & svg {
    color: #fff;
    font-size: 25px;
  }
`;

export const NavContainer = styled(Container)`
  width: 100%;
  height: 100%;
`;

export const Content = styled.nav`
  background-color: ${theme.colors.blue};
  width: 100%;
  display: flex !important;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  min-height: 100vh;

  .align-item-menu {
    color: #fff;
    margin-left: 22px;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
`;

export const AccessibilityReadOnly = styled.span`
  display: none;
  visibility: hidden;
`;

export const UserContainer = styled.div`
  width: calc(100% - 32px);
  display: flex;
  flex-direction: row;
  margin: 0px 15px 0px 17px;
  padding-top: 30px;
`;

export const UserAvatar = styled.div`
  height: 50px;
  width: 50px;
  padding: 5px 5px;
  border-style: solid;
  border-width: 2px;
  border-color: ${theme.colors.lightGreen};
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${theme.colors.lightBlue};
`;

export const UserInitial = styled.span`
  font-size: 30px;
  color: #fff;
  margin-top: 6px;
`;

export const UserDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px 10px 0px 14px;
  justify-content: center;
`;

export const UserName = styled.span`
  font-size: 15px;
  color: #fff;
  font-family: 'Mangueira bold';
  font-family: 'Mangueira';
`;

export const UserLevel = styled.span`
  font-size: 11px;
  color: #feea9b;
`;

export const CompanyContainer = styled.div`
  display: flex;
  background: #fff;
  width: calc(100% - 32px);
  margin: 20px 15px 0px 17px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

export const CompanyText = styled.span`
  font-size: 12px;
  color: white;
  padding: 12px 10px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
`;

export const NavbarComponent = styled(Navbar)`
  background-color: #0b29fb;
  display: none;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 999;
  min-height: 69px;
  padding: 12px 16px;

  @media (max-width: 1100px) {
    display: flex;
    width: 100%;
    position: fixed;
    margin-bottom: 0;
  }
`;

export const IconMenu = styled.div`
  & svg {
    color: #fff;
    font-size: 24px;
  }
`;

export const DivOuterContainer = styled.div`
  background-color: #eff0f0;
  height: 100%;
  overflow-y: scroll;
  ::-webkit-scrollbar-track {
    background-color: #ffffff;
  }
  ::-webkit-scrollbar {
    width: 0.1px;
    background: #ffffff;
  }
  ::-webkit-scrollbar-thumb {
    background: #ffffff;
  }
`;

export const ContentLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const BoxTwoBars = styled('div', { shouldForwardProp })<OpenElement>`
  display: ${({ openElement }) => (openElement ? 'none' : 'flex')};
  flex-direction: row;
`;

export const BoxNameAddress = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Name = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #fff;
  font-family: 'Mangueira Bold', 'Mangueira', sans-serif;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 165px;

  @media (min-width: 320px) {
    max-width: 165px;
  }
  @media (min-width: 375px) {
    max-width: 220px;
  }
  @media (min-width: 425px) {
    max-width: 270px;
  }
  @media (min-width: 560px) {
    max-width: 450px;
  }
`;

export const BoxAddress = styled.div`
  display: flex;
  flex-direction: row;
  flex-direction: column;
`;

export const Address = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 165px;

  @media (min-width: 320px) {
    max-width: 165px;
  }
  @media (min-width: 375px) {
    max-width: 220px;
  }
  @media (min-width: 425px) {
    max-width: 270px;
  }
  @media (min-width: 560px) {
    max-width: 450px;
  }
`;

export const TwoBars = styled.div`
  display: none;
`;

export const ContentSearch = styled('div', { shouldForwardProp })<OpenElement>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ openElement }) => (openElement ? '200px' : '30px')};
  height: 30px;
  background-color: #efefef;
  border-radius: 16px;
  position: relative;
  margin-right: 10px;

  & svg {
    font-size: 20px;
    color: ${theme.colors.primaryText};
    position: absolute;
    top: 5px;
    bottom: 0;
    left: 5px;
  }
`;

export const InputSearch = styled('input', { shouldForwardProp })<OpenElement>`
  width: 100%;
  height: 18px;
  font-size: 14px;
  padding-left: 30px;
  background-color: transparent;
  border: none;
  outline: none;
  color: ${theme.colors.primaryText};
  display: ${({ openElement }) => (openElement ? 'block' : 'none')};
`;
